import { Checkbox, Form } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketMetaField } from "../../../../../../administration/ticket_creation/types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "boolean" }>;
  name: string;
};

export const BooleanInput = observer((props: Props) => {
  return (
    <Form.Item
      name={props.name}
      label={props.field.label}
      help={props.field.description}
      valuePropName="checked"
    >
      <Checkbox />
    </Form.Item>
  );
});
